/**
 * Created by zhouxin on 2019-06-06
 **/
'use strict';
/* Layout */
// import Layout from '../views/layout/Layout'

function _import (file) {
  return require('@/views/' + file + '.vue')
}

export const constantRouterMap = [
  // {path: '/', component: _import('login/login'), hidden: true, meta: { requiresAuth: true }},
  {path: '/login', component: _import('login/login'), hidden: true, meta: { requiresAuth: false }},
  {path: '/register', component: _import('login/register'), hidden: true, meta: { requiresAuth: false }},
  {path: '/forget-password', component: _import('login/changePassword'), hidden: true, meta: { requiresAuth: false }},
  {path: '/404', component: _import('404'), hidden: true, meta: { requiresAuth: false }},
  {path: '/product/buy/:orderId/:token', component: _import('web/wechat/product'), hidden: true, meta: { requiresAuth: false }},
  {path: '/wechat/callback/:token/:openId/:orderId', component: _import('web/wechat/callback'), hidden: true, meta: { requiresAuth: false }},

  // {
  //   path: '/admin',
  //   component: Layout,
  //   children: [{
  //     path: '',
  //     component: _import('HelloWorld'),
  //     name: 'Index',
  //     meta: {title: '主页', icon: 'home'}
  //   }]
  // },
  // {
  //   path: '/admin',
  //   component: Layout,
  //   children: [{
  //     path: 'apps',
  //     component: _import('admin/apps'),
  //     name: 'Apps',
  //     meta: {title: '应用管理', icon: 'mobile-alt'}
  //   }]
  // },
  //
  // {
  //   path: '/admin',
  //   component: Layout,
  //   children: [{
  //     path: 'games',
  //     component: _import('admin/games'),
  //     name: 'Games',
  //     meta: {title: '游戏管理', icon: 'mobile-alt'}
  //   }]
  // },
  //
  // {
  //   path: '/admin',
  //   component: Layout,
  //   children: [{
  //     path: 'appGames',
  //     component: _import('admin/appGames'),
  //     name: 'AppGames',
  //     meta: {title: '应用游戏配置', icon: 'mobile-alt'}
  //   }]
  // },
  //
  // {
  //   path: '/admin',
  //   component: Layout,
  //   children: [{
  //     path: 'products',
  //     component: _import('admin/products'),
  //     name: 'Products',
  //     meta: {title: '商品管理', icon: 'gift'}
  //   }]
  // },
  //
  // {
  //   path: '/admin',
  //   component: Layout,
  //   children: [{
  //     path: 'appProducts',
  //     component: _import('admin/appProducts'),
  //     name: 'AppProducts',
  //     meta: {title: '应用商品配置', icon: 'gift'}
  //   }]
  // },
  //
  // {
  //   path: '/admin',
  //   component: Layout,
  //   meta: {title: '信息统计', icon: 'list'},
  //   children: [
  //     {
  //       path: 'activeUser',
  //       component: _import('admin/statistics/activeUser'),
  //       name: 'ActiveUser',
  //       meta: {title: '活跃用户', icon: 'list'}
  //     },
  //     {
  //       path: 'payUser',
  //       component: _import('admin/statistics/payUser'),
  //       name: 'PayUser',
  //       meta: {title: '充值用户', icon: 'list'}
  //     },
  //     {
  //       path: 'newUser',
  //       component: _import('admin/statistics/newUser'),
  //       name: 'NewUser',
  //       meta: {title: '新用户', icon: 'list'}
  //     },
  //     {
  //       path: 'expenseUser',
  //       component: _import('admin/statistics/expenseUser'),
  //       name: 'ExpenseUser',
  //       meta: {title: '消费钻石', icon: 'list'}
  //     },
  //     {
  //       path: 'totalConsumeDiamond',
  //       component: _import('admin/statistics/totalConsumeDiamond'),
  //       name: 'TotalConsumeDiamond',
  //       meta: {title: '总消费钻石', icon: 'list'}
  //     },
  //     {
  //       path: 'diamond',
  //       component: _import('admin/statistics/diamond'),
  //       name: 'Diamond',
  //       meta: {title: '钻石余额', icon: 'list'}
  //     },
  //     {
  //       path: 'arppu',
  //       component: _import('admin/statistics/arppu'),
  //       name: 'Arppu',
  //       meta: {title: 'ARPPU', icon: 'list'}
  //     },
  //     {
  //       path: 'arpu',
  //       component: _import('admin/statistics/arpu'),
  //       name: 'Arpu',
  //       meta: {title: 'ARPU', icon: 'list'}
  //     }
  //   ]
  // },
  //
  // {
  //   path: '/admin',
  //   component: Layout,
  //   children: [{
  //     path: 'modify-password',
  //     component: _import('admin/password'),
  //     name: 'Password',
  //     meta: {title: '修改密码', icon: 'user'}
  //   }]
  // },
  //
  // {path: '*', redirect: '/404', hidden: true}
];




// WEBPACK FOOTER //
// ./src/router/routers.js